import { render } from "./DaftarKas.vue?vue&type=template&id=7900b4e3"
import script from "./DaftarKas.vue?vue&type=script&lang=js"
export * from "./DaftarKas.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__